import React from 'react';
import { connect } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
import '@pwc/appkit-react/style/appkit-react.default.css';
import constant from '../actions/constant';

export const UserRestriction = ({ brandName }) => (
  <React.Fragment>
    <div className="public-container">
      <div className="login-page account-activation-login row no-gutters p-0 m-0">
        <div className="left-side">
          <div className="bg-block text-center center-block">
            <div className="logo-box-wrapper center-block">
              <div className="logo-box" />
            </div>
            <div className="notice-text">
              <h2>{brandName}</h2>
              <h3>Capture sentiment and uncover insights</h3>
            </div>
          </div>
        </div>
        <div className="right-side">
          <div className="content center-block justify-content-start align-items-center">
            <div className="activation-wrap p-5">
              <div className="activation-inner">
                <div className="activation-icon text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 20 20" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.32345 1.76764C5.9927 0.616664 7.9724 0.000305176 10 0.000305176C12.0276 0.000305176 14.0073 0.616664 15.6766 1.76764C17.3458 2.91862 18.6257 4.54983 19.3466 6.44495C20.0675 8.34008 20.1953 10.4096 19.713 12.379C19.2308 14.3478 18.1626 16.124 16.6476 17.4717C14.8184 19.1031 12.4513 20.0031 10.0006 20C7.54931 20.0034 5.18277 19.1033 3.35337 17.4717C1.83864 16.1242 0.769264 14.3481 0.287023 12.379C-0.195274 10.4096 -0.0675094 8.34008 0.653373 6.44495C1.37426 4.54983 2.6542 2.91862 4.32345 1.76764ZM5.46483 16.5922C6.79152 17.507 8.37192 18.0025 9.99897 18H10.0019C11.6288 18.0023 13.2095 17.5068 14.5361 16.5922C14.0548 16.1229 13.5019 15.7299 12.8964 15.4288C11.997 14.9815 11.0059 14.7491 10.0014 14.75H9.99959C8.99507 14.7491 8.00405 14.9815 7.10462 15.4288C6.4991 15.7299 5.94623 16.1229 5.46483 16.5922ZM16.0308 15.2577C16.8669 14.2984 17.4652 13.1493 17.7704 11.9032C18.1562 10.3277 18.054 8.67212 17.4773 7.15602C16.9006 5.63993 15.8766 4.33496 14.5412 3.41417C13.2058 2.49339 11.6221 2.00031 10 2.00031C8.37792 2.00031 6.79416 2.49339 5.45876 3.41417C4.12336 4.33496 3.09941 5.63993 2.5227 7.15602C1.94599 8.67212 1.84378 10.3277 2.22962 11.9032C2.53472 13.1491 3.13361 14.2983 3.97016 15.2578C4.62266 14.6006 5.38019 14.0527 6.21402 13.638C7.39045 13.0529 8.68663 12.749 10.0005 12.75C11.3144 12.749 12.6106 13.0529 13.787 13.638C14.6208 14.0527 15.3783 14.6005 16.0308 15.2577ZM10.0005 5.75001C9.47007 5.75001 8.96136 5.96072 8.58629 6.3358C8.21122 6.71087 8.0005 7.21958 8.0005 7.75001C8.0005 8.28044 8.21122 8.78915 8.58629 9.16422C8.96136 9.5393 9.47007 9.75001 10.0005 9.75001C10.5309 9.75001 11.0396 9.5393 11.4147 9.16422C11.7898 8.78915 12.0005 8.28044 12.0005 7.75001C12.0005 7.21958 11.7898 6.71087 11.4147 6.3358C11.0396 5.96072 10.5309 5.75001 10.0005 5.75001ZM7.17207 4.92158C7.92222 4.17144 8.93964 3.75001 10.0005 3.75001C11.0614 3.75001 12.0788 4.17144 12.8289 4.92158C13.5791 5.67173 14.0005 6.68915 14.0005 7.75001C14.0005 8.81088 13.5791 9.82829 12.8289 10.5784C12.0788 11.3286 11.0614 11.75 10.0005 11.75C8.93964 11.75 7.92222 11.3286 7.17207 10.5784C6.42193 9.82829 6.0005 8.81088 6.0005 7.75001C6.0005 6.68915 6.42193 5.67173 7.17207 4.92158Z" fill="#BDBDBD" />
                    <path d="M13 8C13 9.65685 11.6569 11 10 11C8.34315 11 7 9.65685 7 8C7 6.34315 8.34315 5 10 5C11.6569 5 13 6.34315 13 8Z" fill="#BDBDBD" />
                    <path d="M5.50186 16.5C6.50186 15 11.0019 13 14.5019 16.5C15.5 18 4.50188 20 5.50186 16.5Z" fill="#BDBDBD" />
                  </svg>
                </div>
                <h4 className="my-4 text-center">User account creation and sign in disabled</h4>
                <p>
                    You can't create an account or sign in as the organisation administrator{' '}
                    has disabled user account creation and sign in.
                </p>

                <p >
                    Please contact your organisation administrator for more information.
                </p>
                <div class="at-footer"><p>© {constant.currentYear} PwC. All rights reserved. PwC refers to the Australia member firm of the PwC network or one of its subsidiaries or affiliates.</p></div>
              </div>

            </div>
          </div>

        </div>

      </div>
    </div>
  </React.Fragment>
);

export default connect(state => ({
  brandName: state.brandwrapper.brandName,
}))(UserRestriction);
